export interface GetDossierTokenApi {
  encryptedInfo: string;
}

export interface exchangeDossierTokenApi {
  access_token: string;
  id_token: string;
  code: string;
  redirect_uri: string;
  businessOrigin?: string;
}

export interface GetPreDeclarationTokenApi {
  token: string;
}
